import { AuxToggle } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { language } from "language/default";
import { gridCurrencySelector, gridInvestorViewSelector, setInvestorView } from "store/grids";
export const InsGridInvestorViewToggle = (props) => {
    const enabled = useSelector((s) => gridInvestorViewSelector(s, props.stateId));
    const currency = useSelector((s) => gridCurrencySelector(s, props.stateId));
    const dispatch = useDispatch();
    if ((!props.investorToggle || !props.currencies?.length) || !currency) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(AuxToggle, { slot: "target", label: language.en.grid.investorToggle, size: props.small ? "small" : "regular", onToggleChanged: (e) => dispatch(setInvestorView({ enabled: Boolean(e.detail.value?.checked), id: props.stateId })), isDisabled: !currency, isChecked: enabled });
};
